import { ProductContext } from '../../../../types/ProductContext';
import { UpdateOrderRequest } from '../../../common/api/clients/order.api';
import { FormikCreateEnquiryValues } from '../../create-enquiry/CreateEnquiryFlow';
import { OrderState } from '../../model/OrderModel';

export const buildOrderRequest = (values: FormikCreateEnquiryValues, state: OrderState): UpdateOrderRequest => {
    const receiverContractIds = values.receiverContractIds.filter((contractId): contractId is string => !!contractId);

    return {
        state: state,
        vesselId: values.vesselId || null,
        agentId: values.agentId || null,
        buyerReference: values.buyerReference ? values.buyerReference : null,
        comment: values.comment || null,
        dateDelivery: values.dateDelivery ? values.dateDelivery : null,
        items: values.items
            .map((item) => ({
                item,
                sourceProductName: item.sourceValues?.product?.name?.trim(),
            }))
            .filter(({ item, sourceProductName }) => item.productId || item.units || sourceProductName)
            .map(({ item, sourceProductName }) => ({
                productId: item.productId || null,
                packType: item.packType,
                unitSize: item.unitSize,
                units: item.units ? Number(item.units) : null,
                unit: item.unit,
                volume: item.volume || null,
                deleted: item.deleted,
                sourceValues: sourceProductName
                    ? {
                          product: {
                              name: sourceProductName,
                          },
                      }
                    : null,
            })),
        portId: values.portId || null,
        receiverSupplierIds: values.receiverSupplierIds?.length ? values.receiverSupplierIds : null,
        receiverContractIds: receiverContractIds.length ? receiverContractIds : null,
        samplekits: values.samplekits?.length
            ? values.samplekits.filter((sampleKit) => sampleKit.name || sampleKit.quantity)
            : null,
        spot: values.spot,
        chosenOfferId: null,
        cancelReason: null,
        type: ProductContext.LUBES,
        fileIds: values.fileIds,
        creationComment: values.creationComment || null,
        scheduleSharingEnabled: values.scheduleSharingEnabled,
    };
};
